import { History } from 'history';
import { HistoryState } from './types';

export const historyLocationState = <T extends HistoryState = HistoryState>(
  history: History
): Partial<T> | undefined => history.location.state as Partial<T>;
